var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 21C13.7968 21.3042 13.505 21.5566 13.154 21.7321C12.803 21.9076 12.4051 22 12 22C11.5949 22 11.197 21.9076 10.846 21.7321C10.495 21.5566 10.2032 21.3042 10 21M17 17H3C3 17 6 14.9516 6 7.78212C5.99877 7.24847 6.06704 6.71735 6.20277 6.20277M19 13C18.5534 11.3727 18.3404 9.69072 18.3675 8.00404C18.3691 6.91799 18.0739 5.85189 17.5141 4.91963C16.9543 3.98737 16.1505 3.22397 15.1887 2.71097C14.2268 2.19797 13.143 1.95463 12.053 2.00696C10.963 2.0593 9.90777 2.40532 9 3.00809M2 2L6.20277 6.20277M22 22L6.20277 6.20277",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellOff);
export default __webpack_public_path__ + "static/media/bell-off.a313987d4457926fe0e30e20e1c747b6.svg";
export { ForwardRef as ReactComponent };